function savePDF() {
  console.warn('[kendo-react-pdf-stub] PDF export is not available in this build.');
}

module.exports = { savePDF };
